//@flow
import React, { Component } from 'react';
import {
  Desktop,
  Default,
  Tablet,
  Device,
  Mobile
} from '../../../components/Responsive';
import { ModelListTh } from '../../../components/ModelListStyles';
import DefaultModelRowTr from '../../../modules/CrudTable/components/DefaultModelRowTr';

type Props = {};

export default class TableHeader extends Component<Props> {
  render() {
    return (
      <DefaultModelRowTr>
        <Default>
          <ModelListTh>Currency</ModelListTh>
          <ModelListTh right>Processing Vol.</ModelListTh>
        </Default>
        <Mobile>
          <ModelListTh>Processing Vol.</ModelListTh>
        </Mobile>
        <Tablet>
          <ModelListTh right>Trans. Fees</ModelListTh>
        </Tablet>
        <Device>
          <ModelListTh right>Comm. Earned</ModelListTh>
        </Device>
        <Desktop>
          <ModelListTh right>Transaction Fees</ModelListTh>
          <ModelListTh right>Commission Earned</ModelListTh>
        </Desktop>
      </DefaultModelRowTr>
    );
  }
}
